import { SET_DELIVERY_PARTNER_DATA } from './constants';

const initialState = {
  list: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DELIVERY_PARTNER_DATA:
      return {
        ...state,
        list: action.payload
      };
    default:
      return state;
  }
};

export default reducer;